module.exports = __webpack_public_path__ + "img/redbook_qr.b5289a0a.jpg";